export enum CmpConfigPublisherRestrictionField {
    PURPOSE = "purpose",
    RESTRICTION_TYPE = "restrictionType",
    VENDORS = "vendors"
}
